export enum GoogleAddressType {
  country = 'country',
  locality = 'locality',
  postalTown = 'postal_town',
  administrativeAreaLevel1 = 'administrative_area_level_1',
  administrativeAreaLevel2 = 'administrative_area_level_2',
  administrativeAreaLevel3 = 'administrative_area_level_3',
  route = 'route',
  streetNumber = 'street_number',
  postalCode = 'postal_code',
}
